import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, Divider } from "@material-ui/core";
import WallpaperRoundedIcon from "@material-ui/icons/WallpaperRounded";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
    background: "whitesmoke",
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  // lineItemBox: {
  //   height: "4.5rem",
  // },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  title2: {
    marginTop: "0.5rem",
  },
  image: {
    width: 50,
    border: "1px solid whitesmoke",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  textLeft: {
    textAlign: "left",
  },
}));

const OrderEditItemRefunded = ({ getImage, removedItems, products }) => {
  const classes = useStyles();

  return (
    removedItems.length > 0 && (
      <Grid container direction="column" justifyContent="flex-start">
        <Paper className={classes.paper}>
          {" "}
          {/* Title */}{" "}
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            className={classes.rowBottom}
          >
            <Grid item>
              <Typography variant="body1" className={classes.title}>
                Removed({removedItems.length}){" "}
              </Typography>{" "}
            </Grid>{" "}
          </Grid>
          {/* Items */}{" "}
          {removedItems.map((each, index) => {
            const item = each.line_item;
            const last = index + 1 === removedItems.length;

            const image =
              products[item.product_id] &&
              getImage(item.variant_id, products[item.product_id]);

            return (
              <Fragment key={index}>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  className={classes.lineItemBox}
                >
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {" "}
                    {image ? (
                      <img className={classes.image} src={image} />
                    ) : (
                      <WallpaperRoundedIcon fontSize="large" />
                    )}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    container
                    direction="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    className={classes.textLeft}
                  >
                    <Grid item> {item.title} </Grid>{" "}
                    <Grid item> {item.variant_title} </Grid>{" "}
                    <Grid item> SKU: {item.sku} </Grid>{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    $ {item.price} & ensp; x & ensp; {item.quantity}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    ${" "}
                    {(
                      parseFloat(item.price) * parseFloat(item.quantity)
                    ).toFixed(2)}{" "}
                  </Grid>{" "}
                </Grid>
                {!last && (
                  <Divider
                    className={classes.divider}
                    orientation="horizontal"
                  />
                )}{" "}
              </Fragment>
            );
          })}{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default OrderEditItemRefunded;
